import BaseService from './baseService'; 

export class ListSensorService extends BaseService {
    constructor(){
        const baseUrl = "/Sensors/List/";
        super(baseUrl);
    }  
} 